<template>
  <!--
    Код взят отсюда: https://github.com/imadovitch/Music-Player-App-built-with-Vue.js-Vue3-and-Howler.js/blob/main/src/views/Home.vue
   -->
  <div class="w-100 position-relative">
    <div class="d-flex col-12 align-items-center justify-content-around pl-0">
      <div class="col-9 d-flex align-items-center pl-1 pr-0">
        <button class="pr-1" @click="playOrPause" v-if="howl">
          <b-icon-pause-fill v-if="howl.playing()" />
          <b-icon-play-fill v-else />
        </button>
        <div>
          <p class="mb-0 mr-1 time">{{ timer }}</p>
        </div>
        <div class="mx-1 position-relative progressbar">
          <div @click="seek($event)" ref="progress" class="progress">
            <div
              class="d-flex justify-content-end"
              :style="{ width: step + '%' }"
            ></div>
          </div>
          <div
            class="d-flex justify-content-end position-relative"
            :style="{ width: step + '%' }"
          >
            <span class="progressButtonTimer rounded-circle"></span>
          </div>
        </div>
        <div>
          <p class="mb-0 mx-1 time">{{ duration }}</p>
        </div>
      </div>

      <div class="d-flex col-3 pl-2 pr-0 align-items-center">
        <button @click="mute" :class="{red: mutePlayer}">
          <b-icon-volume-mute-fill v-if="mutePlayer" />
          <b-icon-volume-up-fill v-else />
        </button>
        <div class="progressbar position-relative">
          <div @click="volume($event)" ref="volBar" class="progress">
            <div
              class="d-flex justify-content-end"
              :style="{ width: volumeProgress + '%' }"
            ></div>
          </div>
          <div
            class="d-flex justify-content-end position-relative"
            :style="{ width: volumeProgress + '%' }"
          >
            <span class="progressButtonVolume rounded-circle"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/sass/custom/colors.scss";
button {
  font-size: 1.5rem;
  color: $primary;
}
.time {
  font-family: "Courier New", Courier, monospace;
  font-size: 0.95rem;
}
.progressbar {
  flex-grow: 1;
  position: relative;
  .progress {
    background: darkgrey;
    cursor: pointer;
    height: 0.5rem;
    border-radius: 9999px;
    position: relative;
    > div {
      height: 0.5rem;
      background-color: $primary;
      border-radius: 9999px;
    }
  }
  .progressButtonTimer,
  .progressButtonVolume {
    position: absolute;
    margin-top: -9px;
    right: -10px;
    height: 1rem;
    width: 1rem;
    background-image: linear-gradient(to right, $primary-400, $primary-700);
  }
}
.red {
  color: #ff0000;
}
</style>

<script>
import { Howl, Howler } from "howler";
import {
  BIconVolumeUpFill,
  BIconVolumeMuteFill,
  BIconPlayFill,
  BIconPauseFill,
} from "bootstrap-vue";

export default {
  name: "AudioPlayer",
  props: {
    src: {
      type: [Array, String],
      required: true,
    },
  },
  components: {
    BIconVolumeUpFill,
    BIconVolumeMuteFill,
    BIconPlayFill,
    BIconPauseFill,
  },

  mounted() {
    let src = Array.isArray(this.src) ? this.src : [this.src];
    this.howl = new Howl({
      src: src,
      html5: true, // A live stream can only be played through HTML5 Audio.
      onplay: () => {
        this.duration = this.formatTime(this.howl.duration());
        requestAnimationFrame(this.stepFunction);
      },
      onseek: () => {
        window.requestAnimationFrame(this.stepFunction);
      },
      onload: () => {
        this.duration = this.formatTime(this.howl.duration());
      },
    });
    Howler.volume(this.volumeProgress / 100);
  },
  destroyed() {
    this.howl.stop();
  },

  data() {
    return {
      timer: "00:00",
      duration: "00:00",
      howl: null,
      step: 0,
      volumeProgress: 80,
      mutePlayer: false,
      lastSeek: 0 // без этого параметра не отображает изменение прогресса при первом клике (howl.seek() в stepFunction() возвращает 0)
    };
  },

  methods: {
    playOrPause() {
      this.howl.playing() ? this.howl.pause() : this.howl.play();
    },
    mute() {
      this.mutePlayer = !this.mutePlayer;
      this.howl.mute(this.mutePlayer);
    },
    volume(event) {
      var per = event.layerX / parseFloat(this.$refs.volBar.scrollWidth);
      this.volumeProgress = per * 100;
      Howler.volume(per);
    },
    seek(event) {
      var per = event.offsetX / this.$refs.progress.clientWidth;
      this.lastSeek = this.howl.duration() * per;

      if (this.howl.playing()) {
        this.howl.pause();
        this.howl.seek(this.lastSeek);
        this.howl.play();
      } else {
        this.howl.stop();
        this.howl.seek(this.lastSeek);
      }
    },
    stepFunction() {
      var seek = this.howl.seek() || this.lastSeek;
      this.timer = this.formatTime(Math.round(seek));
      this.step = (seek * 100) / this.howl.duration();

      if (this.howl.playing()) {
        window.requestAnimationFrame(this.stepFunction);
      }
    },

    formatTime(secs) {
      var minutes = Math.floor(secs / 60) || 0;
      var seconds = Math.floor(secs - minutes * 60) || 0;

      return (
        (minutes < 10 ? "0" : "") + minutes + ":" +
        (seconds < 10 ? "0" : "") + seconds
      );
    },
  },
};
</script>
